import { classNames } from 'tradera/utils/class-names';
import { type FontColor } from 'tradera/components/atoms/text/text';

import styles from './badge.module.scss';

type BadgeProps = React.PropsWithChildren<{
    theme?: FontColor;
    compact?: boolean;
    className?: string;
    fluid?: boolean;
}> &
    (
        | {
              round?: boolean;
              rounded?: never;
          }
        | {
              round?: never;
              rounded?: boolean;
          }
    );

export const Badge = ({
    children,
    className,
    theme,
    compact,
    rounded,
    round,
    fluid
}: BadgeProps) => {
    return (
        <span
            className={classNames(
                styles.badge,
                theme && styles[theme],
                compact && styles.compact,
                round && styles.round,
                rounded && styles.rounded,
                fluid && styles.fluid,
                className
            )}>
            {children}
        </span>
    );
};
